import React from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { Legend, PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer, Tooltip } from 'recharts';
function CustomToolTip({ active, payload }) {
    const theme = useTheme();
    if (!active || !payload || payload.length < 1 || !payload[0].payload) {
        return null;
    }
    const name = payload[0].payload.name;
    const value = payload[0].payload.value;
    const color = payload[0].payload.color;
    return (React.createElement(Stack, { sx: { background: theme.palette.background.paper, opacity: 0.8, padding: 1 } },
        React.createElement(Typography, { variant: "caption", color: color, sx: { lineHeight: '1rem' } }, `${name} : ${value ? parseFloat(value.toString() || '0').toFixed(2) : '-'} \u33AD`)));
}
function AttitudeChart({ attitude, title }) {
    const theme = useTheme();
    if (!attitude) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, { sx: { flex: 1, pb: 1, justifyContent: 'center' } },
        React.createElement(Typography, { variant: "caption" }, title),
        React.createElement(ResponsiveContainer, { width: "100%" },
            React.createElement(RadialBarChart, { data: [
                    { name: 'Pitch', value: attitude.pitch, fill: theme.palette.info.light },
                    { name: 'Yaw', value: attitude.yaw, fill: theme.palette.error.light },
                    { name: 'Roll', value: attitude.roll, fill: theme.palette.warning.light },
                ], innerRadius: "20", outerRadius: "100%", startAngle: 180, endAngle: -180 },
                React.createElement(Tooltip, { content: React.createElement(CustomToolTip, null) }),
                React.createElement(PolarAngleAxis, { type: "number", domain: [0, Math.PI * 2], angleAxisId: 0, tick: false }),
                React.createElement(RadialBar, { dataKey: "value", angleAxisId: 0 }),
                React.createElement(Legend, { wrapperStyle: { fontSize: '0.75rem' }, layout: "vertical", verticalAlign: "middle", align: "left", iconType: "plainline" })))));
}
export default React.memo(AttitudeChart);
